import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import { deleteEntry, JOURNAL_DIALOG_TEXT } from "../../utils";

export default function AlertDialog({
  open,
  setOpen,
  dialogText,
  selectedEntry,
}) {
  const navigate = useNavigate();
  const isDelete = dialogText === JOURNAL_DIALOG_TEXT.delete;

  const deleteEntryFn = async () => {
    try {
      const response = await deleteEntry(selectedEntry.journal_id);
      navigate("/app/journal");
    } catch (error) {}
  };

  const discardEntryChangesFn = () => {
    navigate("/app/journal");
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Journal Entry"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={isDelete ? deleteEntryFn : discardEntryChangesFn}>Yes</Button>
          <Button onClick={handleClose}>No</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
